var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcoholSensitivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004137;}\n\t.st1{fill:#CBD5DC;}\n\t.st2{fill:#A01922;}\n\t.st3{fill:none;stroke:#BD1622;stroke-width:1.3832;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#B1B1B1;stroke-width:1.5465;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.3,113c0,0,26.4-5.8,26.4-42c0-0.5,0-1.7-0.1-2.1c-0.7-3-3.7-3.8-8.9-3.8H85.4c-2.2,0-5.7-0.3-7.3,1.9 c-0.5,0.7-1.6,1.1-1.5,2.4c0,0.2,0.1,1,0.1,1.2c0,36,26.8,42.4,26.8,42.4v26.6c0,0-12,6.1-14.4,7.6c-2.6,1.5-0.9,3.8,0.2,4.2 c1.7,0.7,5.9,2.9,17.8,2.9c12.2,0,16.3-2.4,17.8-2.9c0.6-0.2,3.5-2.4,0-4.5c-6.2-3.7-13.4-7.3-13.4-7.3V113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.3,113c-2.7,0.3-5.2,0.3-7.9,0v26.6c0,0-12,6.1-14.4,7.6c-2.6,1.5-0.9,3.8,0.2,4.2 c1.7,0.7,5.9,2.9,17.8,2.9c12.2,0,16.3-2.4,17.8-2.9c0.6-0.2,3.5-2.4,0-4.5c-6.2-3.7-13.4-7.3-13.4-7.3L111.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.6,68.8c0,4.3-9.3,7.7-30.5,7.7c-21.2,0-30.5-3.5-30.5-7.7c0-4.3,9.3-7.7,30.5-7.7 C128.2,61.1,137.6,64.6,137.6,68.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,67.3c0.6,7.9,1.5,13.6,3,19.8c4.1,16.2,13.5,18.6,21,21c3.3,1.1,6.1,1.3,8.4,0.4 c7.7-3,16.4-10.8,21.1-24.2c1.7-4.8,2.1-9.7,2.6-16c0.5-6.1-56.7-1-56.7-1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.9,84.3c0,10.5,10,25.6,25.1,25.6c15.1,0,26.1-16.4,26.1-25.5C115,84.5,81.9,84.3,81.9,84.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.1,84.3c0,2.5-11.5,4.5-25.6,4.5c-14.1,0-25.6-2-25.6-4.5c0-2.5,11.5-4.5,25.6-4.5 C121.6,79.8,133.1,81.9,133.1,84.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.3,86.9c14.6,3.7,29.9,3.7,44.5,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.9,70.8c18.2,4.7,37.4,4.7,55.6,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcoholSensitivity);
export default __webpack_public_path__ + "static/media/Alcohol_Sensitivity.5c746134f53e2e2a52605738ee040daf.svg";
export { ForwardRef as ReactComponent };